import React from "react";
import { formatWalletAmount } from "./payouts-mock-data";
import payIcon from "../../../../assets/Icons/invoice.svg";

function SummaryRow({ label, value, footer, loading, isLast }) {
  return (
    <div
      className={`flex items-center justify-between gap-4 px-4 py-4 sm:px-5 sm:py-5 ${
        isLast ? "" : "border-b border-[#F3F4F6]"
      }`}
    >
      <div className="min-w-0">
        <p className="my-0 text-[13px] text-[#626262]">{label}</p>
        <p className="my-0 mt-1.5 text-[22px] font-semibold tabular-nums tracking-tight text-[#111827] sm:text-[24px]">
          {loading ? (
            <span className="inline-block h-7 w-28 animate-pulse rounded bg-[#F1F1F1]" />
          ) : (
            value
          )}
        </p>
        {footer ? <div className="mt-1">{footer}</div> : null}
      </div>
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#F8F8F8] sm:h-12 sm:w-12">
        <img src={payIcon} alt="" className="h-6 w-6" />
      </div>
    </div>
  );
}

function DesktopCard({ label, value, footer, loading }) {
  return (
    <div className="flex justify-between border border-solid border-[#EAEAEA80] bg-white px-6 py-5 first:rounded-l-[14px] last:rounded-r-[14px] md:px-8">
      <div className="min-w-0">
        <p className="my-0 text-[13px] text-[#626262]">{label}</p>
        <p className="my-0 mt-2 text-[18px] font-semibold tabular-nums tracking-tight text-[#111827]">
          {loading ? (
            <span className="inline-block h-5 w-20 animate-pulse rounded bg-[#F1F1F1]" />
          ) : (
            value
          )}
        </p>
        {footer ? <div className="mt-2">{footer}</div> : null}
      </div>
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#F8F8F8]">
        <img src={payIcon} alt="" className="h-6 w-6" />
      </div>
    </div>
  );
}

const footerBlue = (text) => (
  <span className="text-left text-[12px] text-[#0088FF]">{text}</span>
);

export function PayoutSummaryCards({ summary, walletLoading }) {
  const earning = summary?.earningCents ?? 0;
  const pending = summary?.pendingCents ?? 0;
  const settled = summary?.settledCents ?? 0;
  const spending = summary?.spendingCents ?? 0;

  return (
    <>
      {/* Mobile: single stacked card (matches design) */}
      <div className="mb-5 overflow-hidden rounded-[14px] border border-[#EFEFEF] bg-white shadow-[0_1px_3px_rgba(15,23,42,0.04)] md:hidden">
        <SummaryRow
          label="Available Balance"
          value={formatWalletAmount(earning)}
          loading={walletLoading}
        />
        <SummaryRow
          label="Pending Clearance"
          value={formatWalletAmount(pending)}
          footer={footerBlue("Clears in 3–5 days")}
          loading={walletLoading}
        />
        <SummaryRow
          label="Total Earned"
          value={formatWalletAmount(settled)}
          footer={footerBlue("All time")}
          loading={walletLoading}
          isLast
        />
      </div>

      {/* Desktop: 4-column strip */}
      <div className="mb-6 hidden grid-cols-4 md:grid">
        <DesktopCard
          label="Spending Balance"
          value={formatWalletAmount(spending)}
          loading={walletLoading}
        />
        <DesktopCard
          label="Earning Balance"
          value={formatWalletAmount(earning)}
          loading={walletLoading}
        />
        <DesktopCard
          label="Pending Clearance"
          value={formatWalletAmount(pending)}
          footer={footerBlue("Clears in 3-5 days")}
          loading={walletLoading}
        />
        <DesktopCard
          label="Total Settled"
          value={formatWalletAmount(settled)}
          footer={footerBlue("All time")}
          loading={walletLoading}
        />
      </div>
    </>
  );
}
